(function () {
  'use strict';

  angular.module('app').component('priceListDetail', priceListDetail());

  function priceListDetail() {
    return {
      bindings: {
        item: '=',
        hideTopControls: '=',
        onSavedItem: '&',
        onCanceledItem: '&',
      },
      controller: PriceListDetailComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/price-lists/price-list-detail/price-list-detail.component.html',
    };
  }

  PriceListDetailComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'PriceListService',
    'SessionService',

    // Angular downgraded service
    'companyService',
    'currencyService',
  ];

  function PriceListDetailComponent(
    config,
    UtilService,
    PriceListService,
    SessionService,

    // Angular downgraded service
    companyService,
    currencyService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    // private properties
    // -----------------------
    const company = SessionService.getSelectedAccountCompany();

    const fieldsDefinition = [
      'name',
      // 'predefined',
      'contact_type',
      'taxes_included',
      'currency_id',
      'related_price_list_id',
    ];

    let lastContactType;
    let lastCurrencyId;

    vm.$onInit = function () {
      if (vm.item.id) {
        vm.flashMessage = vm.UtilService._displayFlashMessage();

        setItemOptions(vm.item);
      } else {
        vm.createMode = true;

        vm.item = {
          taxes_included: false,
          company_id: company.id,
        };
      }

      // Initializers
      getCompany();
      getPriceLists();
      getContactTypes();
    };

    // public methods
    // -----------------------
    vm.selectContactType = function (contact_type) {
      if (contact_type === lastContactType) return;

      lastContactType = contact_type;

      vm.item.related_price_list_id = null;

      if (contact_type === 'provider') return;

      setRelatedPriceLists();
    };

    vm.selectCurrency = function (currency_id) {
      if (currency_id === lastCurrencyId) return;

      lastCurrencyId = currency_id;

      vm.item.related_price_list_id = null;

      if (vm.item.contact_type === 'provider') return;

      setRelatedPriceLists();
    };

    vm.savePriceList = function (isFormValid) {
      vm.fromErrors = false;

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;

        return;
      }

      if (vm.UtilService.isFormDataChanged(vm.item, vm.originalItem, fieldsDefinition)) {
        vm.sendingForm = true;
        let successCallback = () => {
          PriceListService.savePriceList(vm.item, '').then(function (data) {
            const status = data.status;
            const response = data.response;

            console.log(response);

            if (status) {
              // success
              if (!vm.editMode) {
                // create
                vm.onSavedItem({ item: response });
              } else {
                vm.flashMessage = vm.UtilService._clearFlashMessage();

                setItemOptions(response);
              }
            } else {
              vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
              vm.formErrors = true;
            }

            vm.sendingForm = false;
          });
        };

        const cancelCallback = () => {
          vm.item = vm.originalItem;
          vm.originalItem = angular.copy(vm.item);
          vm.sendingForm = false;
        };

        // DRY campbell
        if (vm.item.id === undefined) {
          // TODO: campbell: why? do you mean vm.createMode ??
          successCallback();
        } else if (vm.item.taxes_included !== vm.originalItem.taxes_included) {
          PriceListService.changePriceListIncludeTaxes(successCallback, '', cancelCallback);
        } else {
          successCallback();
        }
      } else {
        vm.cancel();
      }
    };

    vm.cancel = function () {
      vm.onCanceledItem({ item: vm.item });
    };

    // private methods
    // -----------------------
    function setItemOptions(item) {
      vm.editMode = true;

      if (item.currency && item.currency.status !== 'active') {
        item.currency_id = null;
        if (item.currency.status === 'inactive') {
          vm.showCurrencyError = true;
        }
      }

      vm.itemName = item.name;

      vm.originalItem = angular.copy(item); // store server data
    }

    function getCompany() {
      vm.loadingCurrencies = true;
      companyService
        .getCompany(vm.item.company_id, { skip_check_role: true })
        .subscribe((response) => {
          getCurrencies(response.currency_ids);
        });
    }

    function getContactTypes() {
      vm.contactTypes = config.RELATIONSHIP_TYPES;
    }

    function getCurrencies(companyCurrencyIds) {
      let params = {
        get: 'per_company',
        'currency_ids[]': companyCurrencyIds,
        skip_check_role: true,
      };

      currencyService.getCurrencies(params).subscribe((response) => {
        vm.currencies = response;

        vm.currencies.forEach(function (currency) {
          if (currency.is_default && !vm.item.id) {
            vm.item.currency_id = currency.id;
            return;
          }
        });

        vm.loadingCurrencies = false;
      });
    }

    function getPriceLists() {
      let params = {
        get: 'active',
        company_id: company.id,
        skip_check_role: true,
      };

      vm.loadingPriceLists = true;
      PriceListService.getPriceLists(params).then(function (data) {
        vm.priceLists = data.items;

        if (!vm.createMode && vm.item.contact_type === 'client') {
          setRelatedPriceLists();
        }

        vm.loadingPriceLists = false;
      });
    }

    function setRelatedPriceLists() {
      if (!vm.item.contact_type || !vm.item.currency_id) return;

      // Reverse contact type
      vm.relatedPriceLists = vm.priceLists.filter(
        (x) => x.contact_type !== vm.item.contact_type && x.currency_id === vm.item.currency_id
      );
    }
  }
})();
